export default "__VITE_ASSET__DezLsDL6__"